import { useEffect } from "react";
import { lazy, Suspense } from "react";
import "./App.css";

// Impor statis hanya untuk SectionHero (above-the-fold)
import { SectionHero } from "./sections";
import { SectionGaleri } from "./sections";
import { SectionOrganisasi } from "./sections";
import { SectionQuicklinks } from "./sections";
import { SectionRundown } from "./sections";
import { SectionSponsors } from "./sections";
import { SectionPartner } from "./sections";
import { SectionSupport } from "./sections";

// Dynamic imports untuk section below-the-fold
const SectionWelcome = lazy(() =>
  import("./sections").then((module) => ({ default: module.SectionWelcome }))
);
const SectionKategori = lazy(() =>
  import("./sections").then((module) => ({ default: module.SectionKategori }))
);

const SectionFAQ = lazy(() =>
  import("./sections").then((module) => ({ default: module.SectionFAQ }))
);
const SectionDate = lazy(() =>
  import("./sections").then((module) => ({ default: module.SectionDate }))
);

const Beranda = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      {/* Above-the-fold: Langsung dirender */}
      <SectionHero />
      {/* Below-the-fold: Dimuat secara asinkronus */}
      <Suspense fallback={null}>
        <SectionDate />
        <SectionKategori />
        <SectionFAQ />
        <SectionOrganisasi />
        <SectionPartner />
        {/*         <SectionSupport /> */}
        <SectionSponsors />
      </Suspense>
    </div>
  );
};

export default Beranda;
